import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';

export interface ILog {
    milestone: (msg: string) => void;
    verbose: (msg: string) => void;
    trace: (msg: string) => void;
    info: (msg: string) => void;
    warn: (msg: string) => void;
    warning: (msg: string) => void;
    error: (msg: string) => void;
    fatal: (msg: string) => void;
    assert: (condition: boolean | number | string, msg: string | undefined) => void;

    addMiddleware: (modifier: (message: string) => string) => void;
    removeMiddleware: (modifier: (message: string) => string) => void;
}

export function injectLog(container: IContainer = injectOrBuildContainer()): ILog {
    return container.get<ILog>(TYPES.ILog);
}

export function bindLog(val: ILog, container: IContainer = injectOrBuildContainer()): void {
    container.bind<ILog>(TYPES.ILog, val);
}

export function unbindLog(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.ILog);
}
